import { Skeleton } from "@mui/material"
import "./style.css"
import React from "react"


const SessionSkeleton = ({ isCurrent = false }) => (
  <div className={isCurrent ? "current-session-container" : "other-sessions-container"}>
    {!isCurrent && (
      <div className="session-header">
        <Skeleton variant="text" width={120} height={22} />
      </div>
    )}
    {isCurrent && (
      <div className="session-header">
        <Skeleton variant="text" width={100} height={22} />
      </div>
    )}
    <div className="session-item">
      <div className={`session-icon-container ${isCurrent ? "current" : "other"}`}>
        <Skeleton variant="circular" width={24} height={24} />
      </div>
      <div className="session-details">
        <Skeleton variant="text" width={180} height={22} style={{ marginBottom: 2 }} />
        <Skeleton variant="text" width={60} height={16} />
      </div>
    </div>
  </div>
)

const SessionsLoadingSkeleton = () => (
  <div className="sessions-skeleton-container">
    <SessionSkeleton isCurrent={true} />

    <div className="other-sessions-container">
      <div className="session-header">
        <Skeleton variant="text" width={120} height={22} />
      </div>
      <div className="other-sessions-list">
        {[1, 2, 3].map((index) => (
          <div key={index} className="session-item">
            <div className="session-icon-container other">
              <Skeleton variant="circular" width={24} height={24} />
            </div>
            <div className="session-details">
              <Skeleton variant="text" width={160} height={22} style={{ marginBottom: 2 }} />
              <Skeleton variant="text" width={50} height={16} />
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
)

export default SessionsLoadingSkeleton;